import { render, staticRenderFns } from "./basic_info.vue?vue&type=template&id=467d21d4"
import script from "./basic_info.vue?vue&type=script&lang=js"
export * from "./basic_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467d21d4')) {
      api.createRecord('467d21d4', component.options)
    } else {
      api.reload('467d21d4', component.options)
    }
    module.hot.accept("./basic_info.vue?vue&type=template&id=467d21d4", function () {
      api.rerender('467d21d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/monthly_attendance/components/basic_info.vue"
export default component.exports